import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import JobFormPreview from '../components/Jobs/JobFormPreview';
import jobService, { Job } from '../services/jobService';

const EditJobPage: React.FC = () => {
  const { user, isAuthenticated, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [job, setJob] = useState<Job | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadJob = async () => {
      if (!id) {
        setError('Job ID not provided');
        setLoading(false);
        return;
      }

      try {
        const result = await jobService.getJobById(parseInt(id));
        if (result.success && result.data) {
          setJob(result.data.job);
        } else {
          setError(result.message || 'Failed to load job');
        }
      } catch (err: any) {
        setError(err.message || 'An error occurred while loading the job');
      } finally {
        setLoading(false);
      }
    };

    loadJob();
  }, [id]);

  const handleJobFormSuccess = () => {
    navigate('/jobs?mode=employer');
  };

  const handleJobFormCancel = () => {
    navigate('/jobs?mode=employer');
  };

  // Show loading state while auth is being checked
  if (authLoading) {
    return (
      <div className="edit-job-page">
        <div className="container">
          <div className="loading">Kraunama...</div>
        </div>
      </div>
    );
  }

  // Redirect if not authenticated or not an employer
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (user?.user_type !== 'employer') {
    return <Navigate to="/" replace />;
  }

  if (loading) {
    return (
      <div className="edit-job-page">
        <div className="container">
          <p>Kraunamas darbo skelbimas...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="edit-job-page">
        <div className="container">
          <h2>Klaida</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/jobs')}>Grįžti į darbo skelbimus</button>
        </div>
      </div>
    );
  }

  return (
    <div className="edit-job-page">
      <JobFormPreview job={job} onSuccess={handleJobFormSuccess} onCancel={handleJobFormCancel} />
    </div>
  );
};

export default EditJobPage;
